import React from "react";
import { Select, Switch, Form } from "antd";

import { CenteredInputContainer } from "../../Common/UIElements";

const { Option } = Select;

const RoleMapping = ({
  getFieldValue,
  rolesGetData,
  mainRolesGetData,
  mypRoles,
  onMainRoleChange,
  onMainRoleSelect,
  hmgMainGetOptions,
  accessPermissions,
  onRoleChange,
}) => {
  const rolesOptions = rolesGetData?.map((data) => (
    <Option key={data._id}>{data.role_name}</Option>
  ));

  const mainRolesOptions = mainRolesGetData?.map((data) => (
    <Option key={data._id}>{data.main_role_name}</Option>
  ));

  return (
    <CenteredInputContainer>
      <Form.Item
        label="Main Role"
        name="main_role"
        rules={[{ required: true, message: "" }]}
      >
        <Select
          placeholder="Enter Main Role"
          showSearch
          optionFilterProp="children"
          notFoundContent={null}
          onSelect={(data) => onMainRoleSelect(data)}
          onChange={() => onMainRoleChange()}
        >
          {mainRolesOptions}
        </Select>
      </Form.Item>

      <Form.Item
        label="Role"
        name="role"
        rules={[{ required: true, message: "" }]}
      >
        <Select
          placeholder="Enter Role"
          showSearch
          optionFilterProp="children"
          notFoundContent={null}
          onChange={(e) => onRoleChange(e)}
        >
          {rolesOptions}
        </Select>
      </Form.Item>
      <Form.Item
        shouldUpdate={(previous, current) => previous.role !== current.role}
        label="myPerspective User"
        name="myp_solution_access"
        valuePropName="checked"
      >
        <Switch disabled />
      </Form.Item>
      <Form.Item
        shouldUpdate={(previous, current) => previous.role !== current.role}
        label="myDocs User"
        name="my_docs_solution_access"
        valuePropName="checked"
      >
        <Switch disabled />
      </Form.Item>
      <Form.Item
        shouldUpdate={(previous, current) => previous.role !== current.role}
        label="myPlan User"
        name="my_plan_solution_access"
        valuePropName="checked"
      >
        <Switch disabled />
      </Form.Item>
      <div
        // style={
        //   process.env.REACT_APP_PLATFORM_TYPE &&
        //   process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT"
        //     ? { display: "none" }
        //     : { display: "block" }
        // }
      >
        {/* <div
          style={
            getFieldValue("myp_user")
              ? { display: "none" }
              : { display: "none" }
          }
        >
          <Form.Item
            label="MYP Role"
            name="myp_role"
            rules={[
              {
                required: getFieldValue("myp_user"),
                message: "Please Enter MYP Role",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Enter MYP Role"
            >
              {mypRoles.map((d) => (
                <Option key={d.id}>{d.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </div> */}
        <div
          style={
            accessPermissions?.sm_solution_access
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <Form.Item label="HMG" name="corporate_user_hmg">
            <Select
              // onChange={(e) => {
              //   console.log(e);
              //   // corporateUsersHmgOnChange(
              //   //   e,
              //   //   checkMainRoleValue(getFieldValue("main_role")),
              //   // );
              // }}
              placeholder="Enter HMG"
              showSearch
              optionFilterProp="children"
              notFoundContent={null}
              allowClear
            >
              {hmgMainGetOptions}
            </Select>
          </Form.Item>
        </div>
      </div>
    </CenteredInputContainer>
  );
};

export default RoleMapping;
